import ERROR_ICON from '@assets/icons/error.svg'
import { useTranslation } from 'react-i18next'

export const ErrorUI = ({ title, message, buttonLabel, handleClick }) => {
  const { t } = useTranslation()
  return (
    <div className={'flex h-screen flex-col items-center justify-center gap-8 text-center'}>
      <img
        src={ERROR_ICON}
        alt={t('common.errorAlt')}
        width={54}
        height={47}
        className={'mr-8'}
        decoding="async"
      />
      <h2 className={'text-18 mt-24 font-bold'}>{title}</h2>
      {message && <p className={'text-12 text-navy-400'}>{message}</p>}
      {buttonLabel !== '' && handleClick && (
        <button
          className={'bg-navy-900 text-14 rounded-3xl px-16 py-8 text-white'}
          onClick={handleClick}
        >
          {buttonLabel}
        </button>
      )}
    </div>
  )
}
